/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Cashback Not available component
 *
 * @author Yakov Gushchin
 * @author Julia Ignatieva
 * @version 1.12.0
 * @since 1.12.0
 */

import React from 'react';

import { Button, LinkBlock } from '../../../components/common';
import { ImgStatusError, StatusStyled } from '../../../components/common/Block/Img';
import { ELinkTarget } from '../../../components/common/ExternalLink/ExternalLink';
import { IPageCashbackStatusTranslation } from '../../../modules/internationalization/types/pages/cashback';
import { CashbackTextStyled } from './styled/CashbackStyled';

export interface ICashbackNotAvailable {
    onClick: (link: string) => void;
    translation: IPageCashbackStatusTranslation;
    urlHowToGetCashback: string;
}

const CashbackNotAvailable = (props: ICashbackNotAvailable) => (
    <StatusStyled>
        <ImgStatusError/>
        <CashbackTextStyled className="status__title">
            {props.translation.title}
        </CashbackTextStyled>
        <CashbackTextStyled className="status__sub-title">
            {props.translation.text}
        </CashbackTextStyled>
        <div
            className="status__btn"
            onClick={() => props.onClick(props.translation.btn)}
            onMouseDown={(event: React.MouseEvent) => {
                if (event.button !== 1) return;
                props.onClick(props.translation.btn);
            }}
        >
            <LinkBlock
                isExternalUrl={true}
                target={ELinkTarget.BLANK}
                url={props.urlHowToGetCashback}
            >
                <Button>{props.translation.btn}</Button>
            </LinkBlock>
        </div>
    </StatusStyled>
);

export default CashbackNotAvailable;
